<div class="flex flex-col gap-4 w-full">

  <!-- ============ DATI MAPPA INDOOR ============ -->
  <div class="flex flex-col gap-3">
    <div class="flex gap-3 flex-wrap">
      <div class="flex flex-col gap-1 flex-1 min-w-48">
        <label class="text-sm">Cliente</label>
        <select class="e-input" [(ngModel)]="clientFk">
          <option [ngValue]="null">Nessun cliente</option>
          @for (client of clientOptions; track client.id) {
            <option [ngValue]="client.id">{{ client.codice }}</option>
          }
        </select>
      </div>
      <div class="flex flex-col gap-1 w-32">
        <label class="text-sm">Numero piani</label>
        <input
          type="number"
          min="1"
          class="e-input"
          [(ngModel)]="floorCount"
          (ngModelChange)="onFloorCountChange()"
        />
      </div>
    </div>

    <!-- un blocco per piano/planimetria -->
    @for (map of maps; track $index) {
      <div class="flex flex-col gap-2 p-3 rounded-3xl shadow-small">
        <p class="text-sm text-white/60">Planimetria {{ $index + 1 }}</p>

        <div class="flex gap-3 flex-wrap">
          <div class="flex flex-col gap-1 w-24">
            <label class="text-sm">Piano</label>
            <input type="number" class="e-input" [(ngModel)]="map.floor" placeholder="0" />
          </div>
          <div class="flex flex-col gap-1 flex-1 min-w-48">
            <label class="text-sm">Titolo</label>
            <input type="text" class="e-input" [(ngModel)]="map.title" placeholder="Es. Piano Terra" />
          </div>
        </div>

        <div class="flex flex-col gap-1">
          <label class="text-sm">Descrizione</label>
          <textarea class="e-input" rows="2" [(ngModel)]="map.description" placeholder="Descrizione (opzionale)"></textarea>
        </div>

        <div class="flex flex-col gap-2">
          <label class="text-sm">Planimetria</label>
          <input type="file" accept="image/*" (change)="onPlanimetriaSelected($event, $index)" />
          @if (map.image) {
            <img [src]="map.image" alt="Anteprima planimetria" class="max-h-48 w-fit rounded-2xl shadow-small object-contain" />
          }
        </div>
      </div>
    }

    @if (!existingMaps.length) {
      <p class="text-white/50 text-sm">
        Compila i piani e salva la missione: verra fatta una chiamata per planimetria, poi potrai posizionare gli step.
      </p>
    }
  </div>

  <!-- ============ POSIZIONAMENTO STEP (mappe salvate) ============ -->
  @if (savedMaps.length) {
    <div class="flex flex-col gap-3 pt-2 border-t border-white/10">
      <p class="text-lg">Posizionamento step</p>

      <!-- selettore piano -->
      <div class="flex gap-2 flex-wrap">
        @for (map of savedMaps; track map.floor) {
          <button
            type="button"
            class="px-3 py-1 rounded-full transition"
            [class]="map.floor === placementFloor ? 'bg-primary-500 text-black' : 'bg-white/10 hover:bg-white/20'"
            (click)="selectPlacementFloor(map.floor)"
          >
            {{ map.title }} (piano {{ map.floor }})
          </button>
        }
      </div>

      @if (placementMap) {
        <div class="flex flex-col lg:flex-row gap-4">
          <!-- elenco step -->
          <div class="flex flex-col gap-2 lg:w-64 shrink-0">
            <p class="text-sm text-white/70">
              Step
              <span class="text-white/40">— clicca per selezionare, poi clicca sulla planimetria</span>
            </p>
            @for (step of steps; track step.id) {
              <div
                class="flex justify-between items-center gap-2 p-2 rounded-2xl cursor-pointer transition"
                [class]="selectedStep?.id === step.id ? 'bg-primary-500 text-black' : 'bg-white/10 hover:bg-white/20'"
                (click)="selectStep(step)"
              >
                <div class="flex items-center gap-2 min-w-0">
                  @if (isOnCurrentMap(step)) {
                    <mat-icon class="text-emerald-400" style="font-size:18px;width:18px;height:18px">place</mat-icon>
                  }
                  <span class="truncate">{{ step.name }}</span>
                </div>
                @if (isOnCurrentMap(step)) {
                  <button mat-icon-button (click)="removeFromMap(step, $event)">
                    <mat-icon style="font-size:18px;width:18px;height:18px">close</mat-icon>
                  </button>
                }
              </div>
            }
            @if (!steps.length) {
              <p class="text-white/40 text-sm">Nessuno step nella missione.</p>
            }
          </div>

          <!-- planimetria -->
          <div class="flex-1">
            <div
              class="relative w-full rounded-2xl overflow-hidden shadow-small"
              [class.cursor-crosshair]="selectedStep"
              (click)="onMapClick($event)"
            >
              <img [src]="placementMap.image" [alt]="placementMap.title" class="w-full block select-none" draggable="false" />

              @for (step of stepsOnMap; track step.id) {
                <div
                  class="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center pointer-events-none"
                  [style.left.%]="step.x"
                  [style.top.%]="step.y"
                >
                  <mat-icon class="text-primary-500 drop-shadow" style="font-size:32px;width:32px;height:32px">place</mat-icon>
                  <span class="text-xs bg-black/70 text-white px-1 rounded whitespace-nowrap">{{ step.name }}</span>
                </div>
              }
            </div>
            @if (selectedStep) {
              <p class="text-sm text-primary-500 mt-2">
                Clicca sulla planimetria per posizionare "{{ selectedStep.name }}"
              </p>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
